import {Seconds} from '@store/@types/util';
import CallCardActions from '@store/call-card/CallCardActions';
import {CallCardSource} from '@store/call-card/CallCardSource';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import {UserComment} from 'records/UserComment';

import CommentSource from '@store/call-card/CommentSource';

export async function submitComment(
  callId: FileUploadId,
  duration: Seconds,
  newComment: UserComment,
  initialComment: UserComment
) {
  const shouldCreate = await shouldCreateComment(callId, newComment, initialComment);

  // Location causes problems at the source level.
  // We don't use it for CallCard 3.0, so make sure it's not here
  const comment = newComment.set('location', undefined);

  if (newComment.isRange()) {
    // Highlights
    if (shouldCreate) {
      await CommentSource.createHighlight(callId, comment, duration);
    } else {
      await CommentSource.updateHighlight(callId, comment, duration);
    }
  } else {
    // Comments
    if (shouldCreate) {
      await CommentSource.createComment(callId, comment, duration);
    } else {
      await CommentSource.updateComment(callId, comment, duration);
    }
  }

  return refreshComments(callId);
}

// If we change comment types delete the old version before creation.
// Return whether the comment should be created or updated
async function shouldCreateComment(
  callId: FileUploadId,
  newComment: UserComment,
  initialComment: UserComment
): Promise<boolean> {
  // Comment has not been saved yet, create new
  if (!initialComment.id) return true;

  // Previous comment is same type, update
  if (initialComment.isRange() === newComment.isRange()) return false;

  // Comment type is different. Delete old, and create new
  if (initialComment.isRange()) {
    await CallCardSource.deleteHighlight(callId, initialComment.id!);
  } else {
    await CommentSource.deleteComment(callId, initialComment);
  }
  return true;
}

export async function resizeHighlight(callId: FileUploadId, highlight: UserComment, duration) {
  await CommentSource.updateHighlight(callId, highlight, duration);

  return refreshComments(callId);
}

function refreshComments(callId: FileUploadId) {
  // Fetch updated comments/activity data.
  // Activity endpoint hits lots of tables and can take a while
  // on longer accounts, so don't wait for this to complete.
  CallCardActions.getUserCallActivity(callId).catch(console.error);

  return CallCardActions.getComments(callId);
}
